import React from "react";
import PropTypes from "prop-types";
import LocalNavSoftLink from "../LocalNavSoftLink";

export default function SuperAdminExtrasSection({ hasSuperAdmin, hasExperianAdmin }) {
    if (!(hasSuperAdmin || hasExperianAdmin)) return null;

    return (
        <>
            {hasSuperAdmin && (
                <LocalNavSoftLink
                    removeLi
                    id="update-experian-assets"
                    destination="/admin/update-experian-assets"
                    text="Update Experian Assets"
                />
            )}
            {hasSuperAdmin && (
                <LocalNavSoftLink
                    removeLi
                    id="field-config-saa-template"
                    destination="/admin/field-config-saa-template"
                    text="Field Configuration SAA Templates"
                />
            )}
            {(hasSuperAdmin || hasExperianAdmin) && (
                <LocalNavSoftLink
                    removeLi
                    id="saa-advertiser-admin"
                    destination="/admin/saa-advertisers"
                    text="SAA Advertisers"
                />
            )}
            {hasSuperAdmin && (
                <LocalNavSoftLink
                    removeLi
                    id="application-rsa-keys"
                    destination="/admin/application-rsa-keys"
                    text="Application RSA Keys"
                />
            )}
        </>
    );
}

// Mark safe for LocalNavMenu structural expansion (must remain hook-free)
SuperAdminExtrasSection.__localNavSection = true;

SuperAdminExtrasSection.propTypes = {
    hasSuperAdmin: PropTypes.bool.isRequired,
    hasExperianAdmin: PropTypes.bool.isRequired,
};
